export const pick = <T, K extends keyof T>(obj: T, ...keys: K[]): Pick<T, K> => {
  const ret: Partial<Pick<T, K>> = {};
  for (const key of keys) {
    ret[key] = obj[key];
  }
  return ret as Pick<T, K>;
};
